/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;


/**
 * Site constants
  */
'use strict';

var title = 'Baltimore Brew';
var description = 'Baltimore Brew is a daily online journal featuring independent reporting and informed commentary about greater Baltimore.';
var image = '../../../static/logo.png';

module.exports = {

	// Site <META/> tags
	meta: {
		title: title,
		description: description,
		meta: {
			charSet: 'utf-8',
			property: {
				'og:site_name': title,
				'og:image': image,
				'og:locale': 'en_US',
				'og:title': title,
				'og:description': description,
				'twitter:card': 'summary',
				'twitter:site': '@BaltimoreBrew',
				'twitter:creator': '@BaltimoreBrew',
				'twitter:title': title,
				'twitter:description': description,
				'twitter:image': image,
				'twitter:image:width': '1764',
				'twitter:image:height': '333'
			}
		}
	},

	/**
  * Media Query settings
  * Add/removes React elements in the virtual DOM, depending on the size
  * of the viewport, regardless of device.
  */
	media: {
		small: '721px',
		medium: '981px',
		large: '1281px',
		smallViewport: '(min-width: 0px) and (max-width: 720px)',
		mediumViewport: '(min-width: 721px) and (max-width: 980px)',
		largeViewport: '(min-width: 981px) and (max-width: 1280px)'
	},

	// Links
	links: {
		facebook: 'https://www.facebook.com/baltimorebrew',
		twitter: 'http://twitter.com/baltimorebrew'
	},

	// Protocol
	protocol: __DEVELOPMENT__ ? 'http' : 'https',

	// CDN address
	cdn: __DEVELOPMENT__ ? '//localhost/' : '//content.baltimorebrew.com/',

	// Dates
	dates: {
		defaultFormat: 'YYYY-MM-DD HH:mm:ss'
	},

	// Categories that get highlighted in article blocks (red bg, white text).
	// This array should contain the `slug` for the category, found in the
	// Wordpress categories admin panel.
	dominantCategories: ['opinion', 'analysis', 'commentary']
};
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/settings.js
 ** module id = 18
 ** module chunks = 0
 **/